import React, { Fragment, useState } from "react";
import AboutCompanyHelper from "../../Components/AboutCompany/Index";

const AboutCompanyPage = () => {
  return (
    <Fragment>
        <AboutCompanyHelper />
    </Fragment>
  );
}

export default AboutCompanyPage;
